import { createAsyncThunk } from '@reduxjs/toolkit';
import {
	createUser as createUserApi, login as loginApi, logout as logoutApi, getUser as getUserApi, getUsers as getUsersApi
} from '../api';
import { UserInfo } from '../../interfaces/user-info';
import { LoginInfo } from '../../interfaces/login-info';
import {getLayers} from "./map";

export const login = createAsyncThunk<UserInfo, LoginInfo, { rejectValue: string }>(
	'user/login',
	async (loginInfo: LoginInfo, {rejectWithValue, dispatch}) => {
		try {
			const response = await loginApi(loginInfo);
			dispatch(getLayers());
			return response.user;
		} catch (err) {
			if (err instanceof Error) {
				return rejectWithValue(err.message)
			}
			return 'Unknown login error'
		}
	},
)
export const logout = createAsyncThunk(
	'user/logout',
	async (_, { dispatch }) => {
		await logoutApi();
		dispatch(getLayers());
	},
)

export const createUser = createAsyncThunk(
	'user/createUser',
	async (userInfo: UserInfo) => {
		if (localStorage.getItem('accessToken')) {
			try {
				const response = await createUserApi(userInfo);
				return response;
			}
			catch (e) {
				console.log(e);
			}
		} else {
			return null;
		}
	}
);

export const getUser = createAsyncThunk(
	'user/getUser',
	async () => {
		if (localStorage.getItem('accessToken')) {
			try {
				const response = await getUserApi();
				return response;
			}
			catch (e) {
				return Promise.reject(e);
			}
		} else {
			return null;
		}
	}
);

export const getUsers = createAsyncThunk(
	'user/getUsers',
	async () => {
		if (localStorage.getItem('accessToken')) {
			try {
				const response = await getUsersApi();
				return response;
			}
			catch (e) {
				console.log(e);
			}
		} else {
			return null;
		}
	}
);
